import React, { useState } from "react";
import "../../Styles/Profile.css";
import { Form } from "react-bootstrap";
import { format, parseISO } from "date-fns";
import { Formik } from "formik";
import { personalDetailsValidations } from "./profileValidations";
import {
  checkIfEmailExists,
  fetchEmployeeById,
  updateProfile,
} from "../../services/axios/apiManager";
import {
  handleErrors,
  maskContactNumber,
  setUserData,
} from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import LoadingSpinner from "../../Components/spinner";
import { useAppContext } from "../../services/context";

const PersonalDetails = ({
  empData,
  countries,
  provinces,
  cities,
  getProvinces,
  getCities,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setState } = useAppContext();

  const haveToCheckEmail = async (eml) => {
    try {
      if (empData?.id && eml === empData?.email) {
        return false;
      }
      const res = await checkIfEmailExists({ email: eml });
      if (res?.data?.success) {
        return res.data.data;
      } else {
        handleErrors(res, navigate, "Validating Email:");
        return false;
      }
    } catch (error) {
      console.error("Error checking email:", error);
      return false;
    }
  };
  const submitForm = async (values) => {
    const res = await updateProfile(values);
    if (res?.data?.success) {
      toast.success("Profile has been updated", { duration: 2000 });
      await setNewData(empData.id);
    } else {
      handleErrors(res, navigate, "update profile:");
    }
  };
  const setNewData = async (id) => {
    const res = await fetchEmployeeById(id);
    if (res?.data?.success && res?.data?.data) {
      await setUserData(res.data.data);
      setState((prev) => ({ ...prev, user: res.data.data }));
    } else {
      handleErrors(res, navigate, "Refesh user data:");
    }
  };

  return (
    <div className="tab-pane active" id="personalDetails" role="tabpanel">
      <div className="card-header">
        <h6 className="card-title mb-0">Personal Details</h6>
      </div>
      <div className="card-body">
        <Formik
          initialValues={{
            id: empData?.id || "",
            first_name: empData?.first_name || "",
            last_name: empData?.last_name || "",
            email: empData?.email || "",
            mobile_number: empData?.mobile_number || "",
            landline_number: empData?.landline_number || "",
            date_of_birth: empData?.date_of_birth || "",
            address_line_1: empData?.address_line_1 || "",
            address_line_2: empData?.address_line_2 || "",
            country_id: empData?.country_id || "",
            city_id: empData?.city_id || "",
            province_id: empData?.province_id || "",
            zip_code: empData?.zip_code || "",
            emergency_contact_name: empData?.emergency_contact_name || "",
            emergency_contact_number: empData?.emergency_contact_number || "",
          }}
          validationSchema={personalDetailsValidations}
          onSubmit={async (values, { setFieldError }) => {
            try {
              setLoading(true);
              const isEmailExists = await haveToCheckEmail(values.email);
              if (isEmailExists) {
                setFieldError("email", "Email already exists");
              } else {
                submitForm(values);
              }
            } catch (error) {
              console.log("Error in Login", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter your firstname"
                    value={values.first_name}
                    onChange={handleChange("first_name")}
                  />
                  {errors?.first_name && touched?.first_name ? (
                    <span className="text-danger">{errors?.first_name}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter your last name"
                    value={values.last_name}
                    onChange={handleChange("last_name")}
                  />
                  {errors?.last_name && touched?.last_name ? (
                    <span className="text-danger">{errors?.last_name}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    // disabled
                    placeholder="Enter your email"
                    value={values.email}
                    onChange={handleChange("email")}
                  />
                  {errors?.email && touched?.email ? (
                    <span className="text-danger">{errors?.email}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter your mobile number"
                    value={values.mobile_number}
                    onChange={(event) => {
                      setFieldValue("mobile_number", maskContactNumber(event));
                    }}
                  />
                  {errors?.mobile_number && touched?.mobile_number ? (
                    <span className="text-danger">{errors?.mobile_number}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Landline Number</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter Landline number"
                    value={values.landline_number}
                    onChange={(event) => {
                      setFieldValue(
                        "landline_number",
                        maskContactNumber(event)
                      );
                    }}
                  />
                  {errors?.landline_number && touched?.landline_number ? (
                    <span className="text-danger">
                      {errors?.landline_number}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="date_of_birth" className="form-label">Date of Birth</label>
                  <Form.Control
                    id="date_of_birth"
                    type="date"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    value={
                      values?.date_of_birth
                        ? format(parseISO(values.date_of_birth), "yyyy-MM-dd")
                        : ""
                    }
                    onChange={handleChange("date_of_birth")}
                  />
                  {errors?.date_of_birth && touched?.date_of_birth ? (
                    <span className="text-danger">{errors?.date_of_birth}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Address Line 1</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter Adress line 1"
                    value={values.address_line_1}
                    onChange={handleChange("address_line_1")}
                  />
                  {errors?.address_line_1 && touched?.address_line_1 ? (
                    <span className="text-danger">
                      {errors?.address_line_1}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Address line 2</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter Address line 2"
                    value={values.address_line_2}
                    onChange={handleChange("address_line_2")}
                  />
                  {errors?.address_line_2 && touched?.address_line_2 ? (
                    <span className="text-danger">
                      {errors?.address_line_2}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Country</label>
                  <Form.Select
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    value={values.country_id}
                    onChange={(event) => {
                      setFieldValue("country_id", event.target.value);
                      setFieldValue("province_id", "");
                      setFieldValue("city_id", "");
                      getProvinces(event.target.value);
                    }}
                  >
                    <option disabled value="">
                      Select Country
                    </option>
                    <option key={"key"} value={39}>
                      Canada
                    </option>
                    <option key={"key-233"} value={233}>
                      United States
                    </option>
                    {countries?.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.country_name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors?.country_id && touched?.country_id ? (
                    <span className="text-danger">{errors?.country_id}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="countryInput" className="form-label">
                    Province
                  </label>
                  <Form.Select
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    value={values.province_id}
                    onChange={(event) => {
                      setFieldValue("province_id", event.target.value);
                      setFieldValue("city_id", "");
                      getCities(event.target.value);
                    }}
                  >
                    <option disabled value="">
                      Select Province
                    </option>
                    {provinces?.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.province_name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors?.province_id && touched?.province_id ? (
                    <span className="text-danger">{errors?.province_id}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="countryInput" className="form-label">
                    City
                  </label>
                  <Form.Select
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    value={values.city_id}
                    onChange={handleChange("city_id")}
                  >
                    <option disabled value="">
                      Select City
                    </option>
                    {cities?.map((cty) => (
                      <option key={cty.id} value={cty.id}>
                        {cty.city_name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors?.city_id && touched?.city_id ? (
                    <span className="text-danger">{errors?.city_id}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Zip Code</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    minLength={4}
                    maxLength={6}
                    placeholder="Enter zipcode"
                    value={values.zip_code}
                    onChange={handleChange("zip_code")}
                  />
                  {errors?.zip_code && touched?.zip_code ? (
                    <span className="text-danger">{errors?.zip_code}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Emergency Contact Name</label>
                  <input
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter Emergency Contact Name"
                    value={values.emergency_contact_name}
                    onChange={handleChange("emergency_contact_name")}
                  />
                  {errors?.emergency_contact_name &&
                  touched?.emergency_contact_name ? (
                    <span className="text-danger">
                      {errors?.emergency_contact_name}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="emergency_contact_number" className="form-label">
                    Emergency Contact Number
                  </label>
                  <input
                    id="emergency_contact_number"
                    type="text"
                    className="bg-dark text-light border-light input-placeholder-light form-control"
                    placeholder="Enter Emergency Contact Number"
                    name="emergency_contact_number"
                    value={values.emergency_contact_number || ""}
                    onChange={(event) => {
                      setFieldValue(
                        "emergency_contact_number",
                        maskContactNumber(event)
                      );
                    }}
                  />
                  {errors?.emergency_contact_number &&
                  touched?.emergency_contact_number ? (
                    <span className="text-danger">
                      {errors?.emergency_contact_number}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="hstack gap-2 justify-content-end">
                  {loading ? (
                    <LoadingSpinner size={"lg"} />
                  ) : (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Update
                    </button>
                  )}
                  <button type="button" className="btn btn-secondary">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PersonalDetails;
